import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Problem() {
  const cycleSteps = ['Intentas dejarlo', 'Te sientes mal', 'Recaída', 'Culpa', 'Prometes que ahora sí', 'Vuelves a empezar'];
  return <section className="py-24 md:py-32 px-6 bg-[#2D2A26] text-[#FAF8F5]" data-id="element-126">
      <div className="max-w-3xl mx-auto" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-128">
          <h2 className="text-3xl md:text-4xl font-serif mb-6 text-[#F5F3F0]" data-id="element-129">
            El problema real no es "dejarlo"…
          </h2>
          <p className="text-xl text-[#D4D0C8] max-w-2xl mx-auto leading-relaxed" data-id="element-130">
            Es sostenerte cuando aparece el pico. Porque en abstinencia, tu
            cuerpo y tu mente pueden actuar como si estuvieras en peligro.
          </p>
        </motion.div>

        <div className="flex flex-wrap justify-center items-center gap-3 md:gap-4 my-14 max-w-2xl mx-auto" data-id="element-131">
          {cycleSteps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-center gap-3 md:gap-4" data-id="element-132">
              <span className="px-4 py-2 bg-[#3D3A36] rounded-lg text-base md:text-lg font-medium text-[#E5E0D8]" data-id="element-133">
                {step}
              </span>
              {index < cycleSteps.length - 1 && <ArrowRight className="w-4 h-4 text-[#C4956A] flex-shrink-0" data-id="element-134" />}
            </motion.div>)}
          <ArrowRight className="w-4 h-4 text-[#C4956A] rotate-180" data-id="element-135" />
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center mt-16 p-8 md:p-10 border border-[#7C8B6F]/40 rounded-2xl bg-[#7C8B6F]/10" data-id="element-136">
          <p className="text-xl md:text-2xl font-serif text-[#F5F3F0] mb-4 leading-snug" data-id="element-137">
            Lo que necesitas no es más "motivación".
          </p>
          <p className="text-2xl md:text-3xl font-serif text-[#D4915D]" data-id="element-138">
            Lo que necesitas es un sistema.
          </p>
        </motion.div>
      </div>
    </section>;
}